module.exports = __webpack_public_path__ + "static/media/Person.a252607f.png";